module.exports = __webpack_public_path__ + "img/event_user.b6e9a700.png";